import React, { useEffect, useState } from 'react'
import { RenewalsModel } from '../models/RenewalsModel';


interface NumericalMarkingPopupProps {
    agentsList: any[];
    renewalsCount: number;
    filter: any;
    closePopup: Function;
}

const NumericalMarkingPopup: React.FC<NumericalMarkingPopupProps> = ({
    agentsList,
    renewalsCount,
    filter,
    closePopup
}) => {

const renewalsModel: RenewalsModel = new RenewalsModel();
    useEffect(() => {

    }, [])

    const [selectedUserId, setSelectedUserId] = useState<string | "">("");
    const [renewalsInput, setRenewalsInput] = useState<number>(0);

    const [assignments, setAssignments] = useState<
        { userId: string; renewals: number }[]
    >([]);

    const usedRenewals = assignments.reduce((sum, a) => sum + a.renewals, 0);
    const remaining = renewalsCount - usedRenewals;

    const handleAdd = () => {
        if (selectedUserId === "" || renewalsInput <= 0) return;

        // prevent adding same user twice
        if (assignments.some((a) => a.userId === selectedUserId)) return;

        const newList = [
            ...assignments,
            { userId: selectedUserId, renewals: renewalsInput },
        ];

        setAssignments(newList);
        onChange?.(newList);

        setSelectedUserId("");
        setRenewalsInput(1);
    };

    const handleRemove = (userId: string) => {
        const updated = assignments.filter((a) => a.userId !== userId);
        setAssignments(updated);
        onChange?.(updated);
    };

    const savedAllotment = () => {
        debugger;
        var v = assignments;
        var f = filter;

        renewalsModel.renewalSetManualAllotment({ allotments: v, filter: f }).then((res) => {
            closePopup();
        });
    }

    const onChange = filter.onNumericalMarkingChange;

    return (
        <div className="popup-wrapper small-warning">
            <section className="popup-window rtl" style={{ minHeight: '400px', minWidth: '1200px' }}>
                <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            בחירת סימון מספרי לחידושים
                        </div>
                    </div>
                    <div className="popup-body">

                        <div className="filter-row-leads filter-row flex-centered flex-start flex-top">
                            <div style={{ padding: 20, width: 400 }}>
                                <div>
                                    <span><b>סה"כ:</b> {renewalsCount}</span>
                                    <span><b>בהקצאה:</b> {usedRenewals} </span>
                                    <span><b style={{ color: remaining < 0 ? "red" : "green" }}>
                                        נשאר: {remaining}
                                    </b></span>
                                </div>


                                <hr style={{ margin: "20px 0" }} />

                                {/* RESULT TABLE */}

                                {(
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th>איש מכירות</th>
                                                <th>כמות חידושים</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {assignments.map((a) => {
                                                const user = agentsList.find((u) => u.id === a.userId);

                                                return (
                                                    <tr key={a.userId}>
                                                        <td>{user?.fullName}</td>
                                                        <td>{a.renewals}</td>
                                                        <td>
                                                            <button onClick={() => handleRemove(a.userId)}>מחק</button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}

                                            <tr>
                                                <td>
                                                    <select
                                                        value={selectedUserId}
                                                        onChange={(e) => setSelectedUserId(e.target.value)}
                                                        style={{ width: "80%", padding: 6, marginBottom: 10, border: '1px solid #ccc', borderRadius: '4px' }}
                                                    >
                                                        <option value="">בחר איש מכירות</option>
                                                        {agentsList
                                                            .filter((u) => !assignments.some((a) => a.userId === u.id)) // hide already-selected ones
                                                            .map((u) => (
                                                                <option key={u.id} value={u.id}>
                                                                    {u.fullName}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </td>
                                                <td><input
                                                    type="number"
                                                    min={0}
                                                    value={renewalsInput}
                                                    onChange={(e) => setRenewalsInput(Number(e.target.value))}
                                                    style={{ width: "50%", padding: 6, marginBottom: 10 }}
                                                /></td>
                                                <td>
                                                    <button
                                                        onClick={handleAdd}
                                                        disabled={selectedUserId === "" || renewalsInput <= 0 || remaining <= 0}
                                                        style={{ width: "100%", padding: "8px 0" }}
                                                    >
                                                        הוסף
                                                    </button>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>


                    <div className="popup-footer">
                        <button className="button blue blue-border" onClick={() => savedAllotment()}>
                            שמור
                        </button>
                        <button className="button white blue-border" onClick={() => closePopup()}>
                            סגור
                        </button>

                    </div>
                </div>
            </section>
        </div>
    )
}

export default NumericalMarkingPopup